import {useContext, useEffect, useRef, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AuthContext from "context/AuthContext";
import AssetBasic from "./AssetBasic";
import WasteTypesSelect from "./WasteTypesSelect";
import DownloadTypesSelect from "./DownloadTypesSelect";
import axiApi from "ApiCaller";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import {publishEvent} from "core/eventsConnector";
import Form from "react-bootstrap/Form";

const ModalSelectAssetMultiple = ({show, setShow, filtering = {}, chosenIn = [], multiple = false, subtitle = ""}) => {
    const {panel} = useContext(AuthContext);
    const items = useRef({
        all: [],
        available: [],
        chosen: [],
        getCounter: function () {
            return this.available.length + "/" + this.all.length;
        },
    });
    const [available, setAvailable] = useState([]);
    const [chosen, setChosen] = useState([]);
    const [groups, setGroups] = useState([]);
    const [zones, setZones] = useState([]);
    const [routes, setRoutes] = useState([]);
    const coords = useRef({lat: "0", lng: "0", distance: panel.distance});
    const [coordsShow, setCoordsShow] = useState({lat: "0", lng: "0", distance: panel.distance});
    const labelStyle = {width: "100%", fontWeight: "bold", textAlign: "center"};
    const [message, setMessage] = useState("Seleccione los filtros necesarios.");
    const [counter, setCounter] = useState("0/0");
    const [download, setDownload] = useState("");
    const [waste, setWaste] = useState("");
    const styleTrash = {
        position: "absolute",
        right: "24px",
        top: "-4px",
    };
    const filters = useRef({
        list: [],
        chosen: {},
    });

    useEffect(() => {
        axiApi.get("/api/assets/filters/").then((resp) => {
            items.current.chosen = [...chosenIn];
            setChosen([...chosenIn]);
            setGroups(resp.data.filters.groups);
            setZones(resp.data.filters.zones);
            setRoutes(resp.data.filters.routes);
            if (Object.keys(filtering).length) {
                let key;
                for (key in filtering) {
                    if (typeof filtering[key] === "string") {
                        switch (key) {
                            case "coords_lat":
                            case "coords_lng":
                                if (!filtering[key]) continue;
                                let coord = key.split(/_/)[1];
                                coords.current[coord] = filtering[key];
                                setCoordsShow({...coords.current});
                                filters.current.chosen[key] = filtering[key];

                                break;
                            case "download_type":
                                filters.current.chosen[key] = [filtering[key]];
                                setDownload(filtering[key]);
                                break;
                            case "waste_type":
                                filters.current.chosen[key] = [filtering[key]];
                                setWaste(filtering[key]);
                                break;
                            default:
                                filters.current.chosen[key] = [filtering[key]];
                        }
                    } else {
                        filters.current.chosen[key] = filtering[key];
                    }
                }
                onFilter();
            }
            setCounter("0/0");
            setMessage("Seleccione filtros para buscar.");
        });
    }, []);

    const handleClose = () => {
        setShow(false);
    };
    const handleAccept = () => {
        publishEvent("assets:modal:selector", {assets: chosen});
        setShow(false);
    };

    const onFilter = () => {
        let params = {},
            key;
        for (key in filters.current.chosen) {
            params[key] = filters.current.chosen[key];
        }
        let idsNot = items.current.chosen.map((_asset) => _asset.id);
        if (
            "distance" in filters.current.chosen &&
            !("coords_lat" in filters.current.chosen) &&
            !("coords_lng" in filters.current.chosen)
        ) {
            delete params.distance;
            delete filters.current.chosen.distance;
        }

        if (Object.keys(filters.current.chosen).length === 0) {
            setMessage("Debe seleccionar algun filtro para buscar.");
            setAvailable([]);
            setCounter("0/0");
            return;
        }

        axiApi.get("/api/assets/filter/", {params: params}).then((resp) => {
            if (resp.data.items.length) {
                items.current.all = [...resp.data.items];
                items.current.available = resp.data.items.filter((_asset) => !idsNot.includes(_asset.id));
                setAvailable([...items.current.available]);
                setCounter(items.current.getCounter());
            } else {
                setMessage("No se han encontrado resultados.");
                setAvailable([]);
                setCounter("0/0");
            }
        });
    };
    const onSearcher = (e) => {
        const valueSearched = toLowCaseCleanSpaces(e.target.value);
        let _assets = items.current.all.filter((_ass) => {
            let word = toLowCaseCleanSpaces(_ass.uid);
            word += toLowCaseCleanSpaces(_ass.full_address);
            word += toLowCaseCleanSpaces(_ass.uuids);
            return word.includes(valueSearched);
        });
        setAvailable(_assets);
    };
    const deselectAll = (e) => {
        items.current.available = [...items.current.all];
        setAvailable([...items.current.available]);
        setCounter(items.current.getCounter());
        setChosen([]);
    };
    const onDoubleClick = (e) => {
        let column = e.currentTarget.dataset.column;
        let idx = parseInt(e.currentTarget.dataset.idx);

        if (column === "available") {
            let item = {...items.current.available[idx]};
            let available_ = items.current.available.filter((_ass) => _ass.id !== item.id);
            items.current.available = [...available_];
            setAvailable([...available_]);
            multiple ? items.current.chosen.push(item) : (items.current.chosen = [item]);
            setChosen([...items.current.chosen]);
        } else {
            // "selected"
            let item = {...items.current.chosen[idx]};
            let chosen_ = items.current.chosen.filter((_ass, index) => _ass.id !== item.id);
            items.current.chosen = [...chosen_];
            setChosen(chosen_);
            items.current.available.push(item);
            setAvailable([...items.current.available]);
        }
        setCounter(items.current.getCounter());
    };

    const onChangeSelect = (e) => {
        const {name, value} = e.target;
        let named = name.replace("modFilter-", "");
        value ? (filters.current.chosen[named] = [value]) : delete filters.current.chosen[named];

        switch (named) {
            case "download_type":
                setDownload(value);
                break;

            case "waste_type":
                setWaste(value);
                break;
            default:
                break;
        }
    };
    const onChangeWord = (e) => {
        const {value} = e.target;
        value ? (filters.current.chosen.search = value) : delete filters.current.chosen.search;
    };
    const onChangeCoords = (e) => {
        const {name, value} = e.target;
        const named = name.replace("coords_", "");
        coords.current[named] = value;
        setCoordsShow({...coords.current});
        value ? (filters.current.chosen[name] = value) : delete filters.current.chosen[name];
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} size="xl">
                <Modal.Header closeButton className="preview-canvas mb-0 aling-items">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="dumpster" />
                    </div>
                    <div className="d-inline-flex align-items-center">
                        <Modal.Title className="d-inline-flex ms-3">
                            <div>
                                <div>Buscar Contenedores</div>
                                <div>
                                    <small className="h5">{subtitle}</small>
                                </div>
                            </div>
                        </Modal.Title>
                        <div className="d-inline-flex ms-3" role="search">
                            <input
                                className="form-control border-end-0 rounded-0"
                                type="search"
                                placeholder="uuid, dirección"
                                aria-label="Search"
                                onChange={onSearcher}
                            />
                            <span className="input-group-text bg-white border-start-0 rounded-0" id="searcher-icon">
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                            </span>
                        </div>
                        <div className="d-inline-flex ms-3">Selecciona/Deselecciona con doble click.</div>
                    </div>
                </Modal.Header>
                <Modal.Body className="bg-light">
                    <div className="container-fluid">
                        <div className="row selector-multiple-cards">
                            <div className="col-12 mt-3">
                                <div className="row">
                                    <div className="col" style={{maxWidth: "200px"}}>
                                        <div className="mb-3">
                                            <label htmlFor="word" style={labelStyle}>
                                                UUID, UID
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="word"
                                                placeholder="UUID, UID"
                                                onChange={onChangeWord}
                                            />
                                        </div>
                                    </div>
                                    <div className="col" style={{maxWidth: "160px"}}>
                                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>Descarga</label>
                                        <DownloadTypesSelect
                                            multiple={true}
                                            prefix="modFilter-"
                                            value={download}
                                            disabled={"download_type" in filtering}
                                            onChange={onChangeSelect}
                                        />
                                    </div>
                                    <div className="col" style={{maxWidth: "160px"}}>
                                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>Fracción</label>
                                        <WasteTypesSelect
                                            multiple={true}
                                            prefix="modFilter-"
                                            value={waste}
                                            onChange={onChangeSelect}
                                            disabled={"waste_type" in filtering}
                                        />
                                    </div>
                                    <div className="col" style={{maxWidth: "200px"}}>
                                        <label style={labelStyle}>Grupos</label>
                                        <Form.Select
                                            aria-label="Selector de tipos de residuos"
                                            name="modFilter-group"
                                            onChange={onChangeSelect}
                                            defaultValue="">
                                            <option value="">Todos</option>
                                            {groups.map((_it, index) => (
                                                <option value={_it.id} key={index}>
                                                    {_it.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                    <div className="col" style={{maxWidth: "200px"}}>
                                        <label style={labelStyle}>Zonas</label>
                                        <Form.Select
                                            aria-label="Selector de tipos de residuos"
                                            name="modFilter-zone"
                                            onChange={onChangeSelect}
                                            defaultValue="">
                                            <option value="">Todos</option>
                                            {zones.map((_it, index) => (
                                                <option value={_it.id} key={index}>
                                                    {_it.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                    <div className="col" style={{maxWidth: "200px"}}>
                                        <label style={labelStyle}>Rutas</label>
                                        <Form.Select
                                            aria-label="Selector de rutas"
                                            name="modFilter-route"
                                            onChange={onChangeSelect}
                                            defaultValue="">
                                            <option value="">Todos</option>
                                            {routes.map((_it, index) => (
                                                <option value={_it.id} key={index}>
                                                    {_it.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                    <div className="col" style={{maxWidth: "110px"}}>
                                        <button type="button" className="btn btn-outline-secondary mt-4" onClick={onFilter}>
                                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" /> Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="row">
                                    <div className="col" style={{maxWidth: "260px"}}>
                                        <label style={labelStyle}>
                                            <FontAwesomeIcon icon="fa-regular fa-circle-dot" /> Coordenadas
                                        </label>
                                        <div className="row">
                                            <div className="col-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="coords_lat"
                                                    value={coordsShow.lat}
                                                    onChange={onChangeCoords}
                                                />
                                            </div>
                                            <div className="col-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="coords_lng"
                                                    value={coordsShow.lng}
                                                    onChange={onChangeCoords}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col" style={{maxWidth: "110px"}}>
                                        <label style={labelStyle}>
                                            <FontAwesomeIcon icon="fa-regular fa-circle-dot" /> Distancia
                                        </label>
                                        <div className="row">
                                            <div className="col-12">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    name="distance"
                                                    value={coordsShow.distance || panel.distance}
                                                    onChange={onChangeCoords}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-12 available mt-3">
                                <h4 className="text-center">Disponibles: {counter}</h4>
                                <div className="selector-scrollable p-2 border">
                                    <ul className="list-unstyled">
                                        {available.length ? (
                                            available.map((_asset, idx) => (
                                                <li
                                                    className="border rounded p-2 mb-3 bg-white prevent-select"
                                                    role="button"
                                                    key={idx}
                                                    data-idx={idx}
                                                    data-column="available"
                                                    onDoubleClick={onDoubleClick}>
                                                    <AssetBasic asset={_asset} />
                                                </li>
                                            ))
                                        ) : (
                                            <li className="text-center h5">{message}</li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6 col-12 selected mt-3 position-relative d-flex flex-column">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary ms-2"
                                    title="Borra los seleccionados"
                                    onClick={deselectAll}
                                    style={styleTrash}>
                                    <FontAwesomeIcon icon="trash" />
                                </button>
                                <h4 className="text-center">Seleccionados</h4>
                                <div className="selector-scrollable p-2 bg-white">
                                    <ul className="list-unstyled">
                                        {chosen.map((_asset, idx) => (
                                            <li
                                                className="border rounded p-2 mb-3 bg-white prevent-select"
                                                role="button"
                                                key={idx}
                                                data-idx={idx}
                                                data-column="selected"
                                                onDoubleClick={onDoubleClick}>
                                                <AssetBasic asset={_asset} />
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Descartar
                    </Button>
                    <Button variant="primary" onClick={handleAccept}>
                        Seleccionar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalSelectAssetMultiple;
